import {
  ApiResponse,
  appointmentsBaseUrl,
  getData,
} from "@Services/constServices";

export const getAvailableHours_service = async ({
  date,
  employeeId,
  priceServiceId,
  reserveId,
}): Promise<ApiResponse> => {
  let url;
  // Usar endpoint v2: /available-hours en lugar de /Employee/ListAvailableEmployeeHours
  if (reserveId) {
    url = `${appointmentsBaseUrl}/available-hours?date=${date}&EmployeeId=${employeeId}&priceServiceId=${priceServiceId}&reserveIdOnlyForUpdate=${reserveId}`;
  } else {
    url = `${appointmentsBaseUrl}/available-hours?date=${date}&EmployeeId=${employeeId}&priceServiceId=${priceServiceId}`;
  }
  return getData(url);
};
